module.exports = __webpack_public_path__ + "static/media/m3.6108b519.jpg";